module.exports = __webpack_public_path__ + "videos/nft_marketplace.b5ca110.webm";